import { string, bool } from 'prop-types';
import React from 'react';

EyeIcon.propTypes = {
	label: string,
	closed: bool
};

EyeIcon.defaultProps = {
	closed: false,
	label: 'Eye Symbol'
};

export default function EyeIcon(props) {
	const { closed, label, ...rest } = props;
	const Icon = closed ? IconClosed : IconOpen;
	return <Icon {...rest} role="presentation" label={`${closed ? 'Closed' : 'Open'} ${label}`} />;
}

function IconClosed(props) {
	return (
		<svg viewBox="0 0 24 24" {...props}>
			<path
				d="M4.2,12.3c0.5,0.7,1,1.4,1.6,2c1.8,1.9,3.8,2.8,6,2.8s4.1-1,6-2.8c0.6-0.6,1.2-1.3,1.6-2
			c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-1-1.4-1.6-2c-1.8-1.9-3.8-2.8-6-2.8s-4.1,1-6,2.8
			c-0.6,0.6-1.2,1.3-1.6,2C4.1,11.8,4.1,11.9,4,12C4.1,12.1,4.1,12.2,4.2,12.3z M2.1,11.6c0.1-0.2,0.3-0.6,0.7-1.1
			C3.3,9.8,3.9,9,4.6,8.3C6.7,6.1,9.2,4.8,12,4.8s5.3,1.3,7.4,3.4c0.7,0.7,1.3,1.5,1.9,2.3c0.3,0.5,0.5,0.8,0.7,1.1
			c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.3,0.6-0.7,1.1c-0.5,0.8-1.2,1.6-1.9,2.3c-2.1,2.1-4.6,3.4-7.4,3.4s-5.3-1.3-7.4-3.4
			c-0.7-0.7-1.3-1.5-1.9-2.3c-0.3-0.5-0.5-0.8-0.7-1.1C2,12.1,2,11.9,2.1,11.6z M10.7,14.8l-5.9,5.9c-0.4,0.4-1,0.4-1.4,0
			s-0.4-1,0-1.4l6-6C9.1,12.9,9,12.5,9,12c0-1.7,1.3-3.1,3-3.1c0.5,0,0.9,0.1,1.3,0.3l5.9-5.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-6,6
			c0.2,0.4,0.3,0.8,0.3,1.3c0,1.7-1.3,3.1-3,3.1C11.5,15.1,11.1,15,10.7,14.8z"
			/>
		</svg>
	);
}

function IconOpen(props) {
	return (
		<svg viewBox="0 0 24 24" {...props}>
			<path
				d="M4.2,12.3c0.5,0.7,1,1.4,1.6,2c1.8,1.9,3.8,2.8,6,2.8s4.1-1,6-2.8c0.6-0.6,1.2-1.3,1.6-2
				c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-1-1.4-1.6-2c-1.8-1.9-3.8-2.8-6-2.8s-4.1,1-6,2.8
				c-0.6,0.6-1.2,1.3-1.6,2C4.1,11.8,4.1,11.9,4,12C4.1,12.1,4.1,12.2,4.2,12.3z M2.1,11.6c0.1-0.2,0.3-0.6,0.7-1.1
				C3.3,9.8,3.9,9,4.6,8.3C6.7,6.1,9.2,4.8,12,4.8s5.3,1.3,7.4,3.4c0.7,0.7,1.3,1.5,1.9,2.3c0.3,0.5,0.5,0.8,0.7,1.1
				c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.3,0.6-0.7,1.1c-0.5,0.8-1.2,1.6-1.9,2.3c-2.1,2.1-4.6,3.4-7.4,3.4s-5.3-1.3-7.4-3.4
				c-0.7-0.7-1.3-1.5-1.9-2.3c-0.3-0.5-0.5-0.8-0.7-1.1C2,12.1,2,11.9,2.1,11.6z M12,15.1c1.7,0,3-1.4,3-3.1s-1.3-3.1-3-3.1
				S9,10.3,9,12S10.3,15.1,12,15.1z"
			/>
		</svg>
	);
}
